document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth >= 1024) {
    const swatches = document.querySelectorAll('.swatches.swatch__button');

    const legendValue = document.querySelector('.radio__legend__value');
    const defaultSiblingColor = legendValue.textContent;
  
    swatches.forEach(swatch => {
      swatch.addEventListener('mouseover', () => {
        const tooltipValue = swatch.dataset.tooltip;
        if (tooltipValue) {
          legendValue.textContent = tooltipValue;
        }
      });
  
      swatch.addEventListener('mouseout', () => {
        legendValue.textContent = defaultSiblingColor;
      });
    });
  };
});